export default "__VITE_ASSET__DymcePN7__"